import {
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import deactivateIcon from "../../asserts/logo/DeactivateIcon.svg";

/**
 * Figma: confirm deactivation of a Canonical risk.
 */
export default function DeactivateRiskDialog({ risk, onClose, onConfirm, submitting }) {
  const open = Boolean(risk);
  const riskName = (risk?.name || "").trim() || "this risk";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "4px",
          p: { xs: 2.5, sm: 3 },
          maxWidth: 480,
          position: "relative",
          boxShadow: "0 20px 40px rgba(16, 24, 40, 0.18)",
        },
      }}
      slotProps={{
        backdrop: {
          sx: { bgcolor: "rgba(52, 64, 84, 0.45)" },
        },
      }}
    >
      <IconButton
        size="small"
        onClick={onClose}
        aria-label="Close"
        sx={{
          position: "absolute",
          top: 12,
          right: 12,
          color: "#667085",
        }}
      >
        <CloseIcon sx={{ width: 24, height: 24 }} />
      </IconButton>

      <Box sx={{ textAlign: "center", pt: 1 }}>
        <Box
          component="img"
          src={deactivateIcon}
          alt="Deactivate"
          sx={{
            width: 43,
            height: 39,
            display: "inline-block",
            mb: 2,
          }}
        />

        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 900,
            color: "#000000",
            lineHeight: "27px",
            mb: "16px",
            px: 1,
            textAlign: "center",
            letterSpacing: 0,
          }}
        >
          Deactivate {riskName}?
        </Typography>

        <Typography sx={{ fontSize: "14px", color: "#555555", lineHeight: "21px", mb: 3, px: 0.5 }}>
          This risk stays in the register. Metrics linked to it are deactivated
          and hidden until you activate the risk again.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={submitting}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: "#005BF0",
              borderColor: "#005BF0",
              borderRadius: "4px",
              px: 2.5,
              minWidth: 100,
              "&:hover": { borderColor: "#1251c0", bgcolor: "rgba(26, 110, 245, 0.04)" },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={submitting}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              bgcolor: "#005BF0",
              borderRadius: "4px",
              px: 2.5,
              minWidth: 110,
              boxShadow: "none",
              "&:hover": { bgcolor: "#1251c0", boxShadow: "none" },
            }}
          >
            Deactivate
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
